// See README.md under 'Versioning' for more details
export const SEMANTIC_RELEASE_VERSION = process.env.REACT_APP_SEMANTIC_RELEASE_VERSION;
